// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JobSection-module_wrapper_03140","title":"JobSection-module_title_01121","line":"JobSection-module_line_79d1c","text":"JobSection-module_text_2deff"};